import React from "react";
import { useDispatch } from "react-redux";
import { Button, SVG } from "triider-components";
import { Creators as UiCreators, growlTypes } from "store/ducks/ui";
import { getErrorMessage } from "utils/filters";
import { getCheckoutLink } from "config/checkout";

export function uiHelpers() {
  const dispatch = useDispatch();

  function dispatchError(error) {
    const msg = getErrorMessage(error);
    dispatch(UiCreators.growl(msg, growlTypes.GROWL_ERROR));
  }

  function dispatchSuccess(msg) {
    dispatch(UiCreators.growl(msg, growlTypes.GROWL_SUCCESS));
  }

  function copyCheckoutTokenToClipboard(token) {
    const tempInput = document.createElement("input");
    tempInput.style = "position: absolute; left: -1000px; top: -1000px";
    tempInput.value = getCheckoutLink(token);
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    dispatchSuccess("Link copiado!");
  }

  return { dispatchError, dispatchSuccess, copyCheckoutTokenToClipboard };
}

export function ButtonCopyCheckoutLink({ task, ...props }) {
  const { checkout_token, status, payment_user_id } = task || {};
  if (!checkout_token || payment_user_id || status !== "hired") {
    return null;
  }

  const { copyCheckoutTokenToClipboard } = uiHelpers();
  return (
    <Button
      background="alabaster3"
      borderRadius="10px"
      border="alto3"
      noUpperCase
      height="25"
      maxWidth="190px"
      minWidth="190px"
      width="190px"
      fontSize="10"
      weight="normal"
      color="greyDark"
      onClick={() => copyCheckoutTokenToClipboard(checkout_token)}
      svgLeft={<SVG.CreditCard color="greyDark" />}
      {...props}
    >
      Copiar link de pagamento
    </Button>
  );
}

export const PaymentMethods = {
  DOC: "DOC",
  CREDIT_CARD: "CREDIT_CARD"
};
